var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98906 2.0375L6.50156 3.5H3C1.34531 3.5 0 4.84531 0 6.5V18.5C0 20.1547 1.34531 21.5 3 21.5H21C22.6547 21.5 24 20.1547 24 18.5V6.5C24 4.84531 22.6547 3.5 21 3.5H17.4984L17.0109 2.0375C16.7062 1.11875 15.8484 0.5 14.8781 0.5H9.12188C8.15156 0.5 7.29375 1.11875 6.98906 2.0375ZM12 17C9.51562 17 7.5 14.9844 7.5 12.5C7.5 10.0156 9.51562 8 12 8C14.4844 8 16.5 10.0156 16.5 12.5C16.5 14.9844 14.4844 17 12 17Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSolid);
export default __webpack_public_path__ + "static/media/camera-solid.d4d78b75473decdd71e77cbe4d2f28db.svg";
export { ForwardRef as ReactComponent };